import Tabs from "aws-northstar/components/Tabs";
import React, { FunctionComponent } from "react";
import Stack from "aws-northstar/layouts/Stack";

import PendingTable from "./PendingTable";
import ReviewedTable from "./ReviewedTable";

const tabs = [
    {
        label: "Pending requests",
        id: "first",
        content: <PendingTable />,
    },
    {
        label: "Reviewed requests",
        id: "second",
        content: <ReviewedTable />,
    },
];

const ReviewView: FunctionComponent = () => {
    return (
        <Stack>
            <Tabs tabs={tabs} variant="container" />
        </Stack>
    );
};

export default ReviewView;
